module.exports = __webpack_public_path__ + "img/personal_deposit.58cd6569.svg";